import type { QueryClient } from '@tanstack/react-query';
import { getApplicationQueryKey } from '@/components/candidate-job-slider-v1/hooks/useApplicationHelper';

export type AutomationTriggerScope = {
  jobId?: string | number;
  candidateIds?: Array<string | number>;
};

// Refresh the candidate list + every drawer pinned to one of these
// applications so a freshly-triggered automation surfaces in the activity
// timeline. The candidate already moved at confirm time, so these refetches
// mainly pull in the new stage_actions / next_action info.
//
// Shared by the popup's own dispatcher (post-undo trigger) and the silent
// re-entry trigger, so both paths leave the caches in the same state.
export const invalidateAfterAutomationTrigger = (
  queryClient: QueryClient,
  { jobId, candidateIds = [] }: AutomationTriggerScope
): void => {
  if (jobId) {
    queryClient.invalidateQueries({
      queryKey: ['getCandidateList', Number(jobId)],
    });
  }
  candidateIds.forEach((id) => {
    queryClient.invalidateQueries({
      queryKey: getApplicationQueryKey(String(id)),
    });
  });
};
